const state = {
  username: '',
  password: ''
}

const getters = {
  getLoginUsername: state => {
    return state.username
  },
  getLoginPassword: state => {
    return state.password
  }
}

const mutations = {
  setUsername: (state, payload) => {
    state.username = payload
  },
  setPassword: (state, payload) => {
    state.password = payload
  }
}

const actions = {
  username: ({ commit }, payload) => {
    commit('setUsername', payload)
  },
  password: ({ commit }, payload) => {
    commit('setPassword', payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Login.js